export const MarketplaceOrderItemLabelTextHelper = {
    getLabelText: {
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        sku: 'SKU',
        quantity: 'Quantity',
        itemUnitPriceAmount: 'Item Unit Price',
        totalItemPrice: 'Total Item Price',
        itemUnitPriceCurrencyCode: 'Item Unit Price Currency',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateOrderOnFrom: 'Order Date From',
        dateOrderOnTo: 'Order Date To',
        action: 'Action'
    }
};
